import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ViewController, ModalController, AlertController, Events, Platform} from 'ionic-angular';
import { MailProvider } from '../../providers/mail/mail';
import moment from 'moment';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { AppState } from '../../config/state';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { SoundsProvider } from '../../providers/sounds/sounds';


@Component({
  selector: 'page-co-event-email-share',
  templateUrl: 'co-event-email-share.html',
})
export class CoEventEmailSharePage {
  private event: any;
  email: string;
  private emailRegex: any;
  private clientKeyword: any;
  private clientName: any;
  private qrData: any;
  private unregisterBackButtonAction: any;
  eventTypes: any;
  @ViewChild('scrollableContent') private scrollableContent: any;
  constructor(private platform: Platform, public navCtrl: NavController, public navParams: NavParams,private alerter: AlertController, public mailProvider : MailProvider, public viewCtrl: ViewController, public modalCtrl: ModalController, private toast: ToastAlertsProvider, private clientDetails: ClientDetailsProvider, private state: AppState, private events : Events, private timeout : TimeoutFunctionsProvider, private sounds : SoundsProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.event = this.navParams.data.event;
    let self = this;
    this.clientDetails.load().then((res) =>{
      self.clientKeyword = res.keyword;
      self.clientName = res.longName;
      self.setQrData(res.keyword);
    });
    this.eventTypes = this.state.eventColors.types;
    if (this.state.patron && !this.state.staff && !this.state.isRoam) {
      this.email = this.state.patron.email;
    }
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  ionViewDidEnter() {
    this.unregisterBackButtonAction = this.platform.registerBackButtonAction( () => {
      this.hideModal();
    }, 20);
  }
  ionViewWillLeave() {
    this.unregisterBackButtonAction();
  }

  hideModal() {
    this.viewCtrl.dismiss().catch(err=>{});
  }

  setQrData(keyword){
    this.qrData = `https://${keyword}.libnet.info/event/${this.event.eventId}`
  }

  checkEmailAddress(){
    if (this.emailRegex.test(this.email)){
      this.emailEvent(this.email);

    } else {
      this.toast.triggerToast('Please enter a valid email!', '');
    }
  }
  scrollToBottom() {
    setTimeout(() => {
      this.scrollableContent.scrollToBottom(300);
    }, 600);
  }
  showAlert(title, message) {
    let alert = this.alerter.create({
      title: title,
      subTitle: message,
      buttons: ['OK']
    });

    alert.present();
  }

  getEventImage(eventType) {
    try {
      let eventTypeObject = this.eventTypes.find(object => object.name === eventType);
      return eventTypeObject.image;
    } catch (ex) {
      return "";
    }
  }

  emailEvent(email){
    let ifRegister;
    if (this.event.registrationOpens){
      ifRegister = `Thank you for your interest, please follow the link to register.`
    } else if (!this.event.registrationOpens){
      ifRegister = `Thank you for your interest, see you at the ${(this.state.customStrings.events && this.state.customStrings.events.singular ? this.state.customStrings.events.singular : 'event').toLowerCase()}!`
    }
    let params = {
      template: "event_information_share",
      email: email,
      phone: "",
    }
    let content = {
      locationName: this.event.locationName,
      eventTitle: this.event.title,
      eventDate: moment(this.event.eventStart).format('dddd, MMMM DD, YYYY'),
      eventStart: moment(this.event.eventStart).format('h:mma'),
      eventEnd: moment(this.event.eventEnd).format('h:mma'),
      eventLink: `https://${this.clientKeyword}.libnet.info/event/${this.event.eventId}`,
      ifRegister: ifRegister
    }
    // let emailTemplate =
    // `Dear patron,

    // Thanks for your interest in ${this.event.title}!

    // Here is the information about the event:
    // Location: ${this.event.locationName},
    // Date: ${moment(this.event.eventStart).format('dddd, MMMM DD, YYYY')},
    // Time: ${moment(this.event.eventStart).format('h:mma')} - ${moment(this.event.eventEnd).format('h:mma')},
    // Link: https://${this.clientKeyword}.libnet.info/event/${this.event.eventId}

    // ${ifRegister}

    // ${this.clientName}
    // `
    this.mailProvider.sendEventInfoShareEmail(params, content);
    this.toast.triggerToast((this.state.customStrings.events && this.state.customStrings.events.singular ? this.state.customStrings.events.singular : 'event') + ' information sent successfully.', '', 'success');
    this.hideModal();
  }

}



// WEBPACK FOOTER //
// ./src/pages/co-event-email-share/co-event-email-share.ts